/**
 * Paths for calendar data.
 * - proxy: under our Next.js API (/api/calendar/...)
 * - upstream: external API (server-side). calendarData is dynamic (v2.1/calendar/{type}).
 */
export const calendarDataRoutes = {
  calendarData: { proxy: 'calendar', upstreamPath: 'v2.1/calendar' },
  companyEvents: { proxy: 'calendar/events', upstream: 'v2/calendar/events' },
  ratingsAnalysts: { proxy: 'calendar/ratings/analysts', upstream: 'v2.1/calendar/ratings/analysts' },
  secCalendarData: { proxy: 'calendar/sec', upstream: 'v2/calendar/sec' },
} as const;
